import classNames from "classnames";
import { storage } from "services/storage";

// * Chat message bubble component to show single text
export const MessageBubble = ({ data = {}, className, wrapperClassName }) => {
  const { type, content } = data;
  const isUserMsg = type === "user";
  const user = storage.get.user()
  const userName = user?.username ?? ""

  return (
    <div
      className={classNames(
        "flex items-start gap-2 text-base font-medium",
        wrapperClassName,
        {
          "justify-end": isUserMsg,
        }
      )}
    >
      {!isUserMsg && <img className="w-[40px] h-auto border-2 border-gray-300 rounded-full" src={require("assets/images/BotImage.jpg")} alt="" />}
      {isUserMsg && userName && <span className="uppercase text-xs font-semibold text-[#3D2F52] bg-[#E4DDEF] rounded-full p-1.5">
        {userName?.split(" ")?.[0]?.[0] ?? ""}{userName?.split(" ")?.[1]?.[0] ?? ""}
      </span>
      }
      <p
        className={classNames(
          "w-fit px-5 py-3 font-normal text-base break-words max-w-[75vw]",
          {
            "rounded-l-3xl rounded-br-3xl bg-[#F9E4CB]": !isUserMsg,
            "rounded-r-3xl rounded-bl-3xl bg-[#F2F2F2]": isUserMsg,
          },
          className
        )}
      >
        {content}
      </p>
    </div>
  );
};
